/** Who makes up the red "still banked" vacation total — one row per employee with money owed. */
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const money = (n) => `$${Number(n || 0).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function VacationOwedDialog({ open, onClose, rows, total }) {
  const owed = rows.filter((r) => (r.totals?.vacation_banked || 0) > 0).sort((a, b) => b.totals.vacation_banked - a.totals.vacation_banked);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto bg-white text-gray-800 sm:max-w-md" data-testid="vacation-owed-dialog">
        <DialogHeader>
          <DialogTitle>Vacation pay still banked — {money(total)}</DialogTitle>
          <DialogDescription className="text-gray-500">Live vacation bank per employee (accrued − paid out, including adjustments). Pay it out from the Payroll grid's Vacation column.</DialogDescription>
        </DialogHeader>
        {owed.length === 0 ? (
          <p className="py-4 text-center font-mono text-xs text-gray-500">Nobody has vacation pay banked right now.</p>
        ) : (
          <table className="w-full text-sm">
            <thead><tr className="font-mono text-[9px] uppercase tracking-widest text-gray-500"><th className="py-1 text-left">Employee</th><th className="text-right">Banked</th><th className="text-right">Earned {new Date().getFullYear()}</th></tr></thead>
            <tbody>
              {owed.map((r) => (
                <tr key={r.employee_id} className="border-t border-gray-200" data-testid={`vacation-owed-${r.employee_id}`}>
                  <td className="py-1.5">{r.name}{r.status !== "Active" ? <span className="ml-1 font-mono text-[10px] text-gray-400">· {r.status}</span> : null}</td>
                  <td className="text-right font-mono font-bold tabular-nums text-red-600">{money(r.totals.vacation_banked)}</td>
                  <td className="text-right font-mono tabular-nums text-gray-500">{money(r.totals.vacation_pay)}</td>
                </tr>
              ))}
              <tr className="border-t-2 border-gray-300 font-bold"><td className="py-1.5">Total</td><td className="text-right font-mono tabular-nums text-red-600">{money(total)}</td><td /></tr>
            </tbody>
          </table>
        )}
      </DialogContent>
    </Dialog>
  );
}
